// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ConfigurationComparisonDimensionsQueryVariables = Types.Exact<{
  productOfferingIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type ConfigurationComparisonDimensionsQuery = { __typename?: 'Query', potentialBidPlanDimensions: Array<{ __typename?: 'PotentialBidPlanDimensionResult', id: string, kind: Types.PotentialBidPlanDimensionKind, displayName: string, type?: { __typename?: 'GlobalOptionType', id: string, isSpecLevel: boolean } | null | undefined, options: Array<{ __typename?: 'GlobalOption', id: string, name: string }> }> };

export type ConfigurationComparisonOptionsQueryVariables = Types.Exact<{
  productOfferingIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  typeIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type ConfigurationComparisonOptionsQuery = { __typename?: 'Query', readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string }, globalOption: { __typename?: 'GlobalOption', id: string } }> };

export type ConfigurationComparisonCombinationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.CostConfigurationSummariesFilter>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type ConfigurationComparisonCombinationsQuery = { __typename?: 'Query', costConfigurationSummaries: { __typename?: 'CostConfigurationSummariesPage', entities: Array<{ __typename?: 'CostConfigurationSummary', id: string, pinnedGlobalOptionIds: Array<string>, productOffering: { __typename?: 'ProductOffering', id: string } }> } };

export type ConfigurationComparisonQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.CostConfigurationSummariesFilter>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type ConfigurationComparisonQuery = { __typename?: 'Query', costConfigurationSummaries: { __typename?: 'CostConfigurationSummariesPage', entities: Array<{ __typename?: 'CostConfigurationSummary', id: string, totalCostInCents: number, totalPriceInCents: number, costPerSellableSqftInCents: number, pricePerSellableSqftInCents: number, contingencyInCents: number, indirectCostInCents: number, directCostInCents: number, provisionalCostsInCents: number, provisionalPercentage: number, softCostInCents: number, productOffering: { __typename?: 'ProductOffering', contingencyMarkupPercentage?: number | null | undefined, id: string, name: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string } }, expandedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, pinnedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string }, type: { __typename?: 'GlobalOptionType', id: string } }>, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined } }> } };

export type ConfigurationComparison_PotentialBidPlanDimensionResultFragment = { __typename?: 'PotentialBidPlanDimensionResult', id: string, kind: Types.PotentialBidPlanDimensionKind, displayName: string, type?: { __typename?: 'GlobalOptionType', id: string, isSpecLevel: boolean } | null | undefined, options: Array<{ __typename?: 'GlobalOption', id: string, name: string }> };

export type ConfigurationComparison_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, order: number, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string }, globalOption: { __typename?: 'GlobalOption', id: string } };

export type ConfigurationComparison_CombinationFragment = { __typename?: 'CostConfigurationSummary', id: string, pinnedGlobalOptionIds: Array<string>, productOffering: { __typename?: 'ProductOffering', id: string } };

export type ConfigurationComparison_CostConfigurationSummaryFragment = { __typename?: 'CostConfigurationSummary', id: string, totalCostInCents: number, totalPriceInCents: number, costPerSellableSqftInCents: number, pricePerSellableSqftInCents: number, contingencyInCents: number, indirectCostInCents: number, directCostInCents: number, provisionalCostsInCents: number, provisionalPercentage: number, softCostInCents: number, productOffering: { __typename?: 'ProductOffering', contingencyMarkupPercentage?: number | null | undefined, id: string, name: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string } }, expandedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, pinnedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string }, type: { __typename?: 'GlobalOptionType', id: string } }>, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined } };

export const ConfigurationComparison_PotentialBidPlanDimensionResultFragmentDoc = gql`
    fragment ConfigurationComparison_PotentialBidPlanDimensionResult on PotentialBidPlanDimensionResult {
  id
  kind
  displayName
  type {
    id
    isSpecLevel
  }
  options {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const ConfigurationComparison_ReadyPlanOptionFragmentDoc = gql`
    fragment ConfigurationComparison_ReadyPlanOption on ReadyPlanOption {
  id
  order
  readyPlan {
    ...Named
  }
  globalOption {
    id
  }
}
    ${NamedFragmentDoc}`;
export const ConfigurationComparison_CombinationFragmentDoc = gql`
    fragment ConfigurationComparison_Combination on CostConfigurationSummary {
  id
  productOffering {
    id
  }
  pinnedGlobalOptionIds
}
    `;
export const ConfigurationComparison_CostConfigurationSummaryFragmentDoc = gql`
    fragment ConfigurationComparison_CostConfigurationSummary on CostConfigurationSummary {
  id
  totalCostInCents
  totalPriceInCents
  costPerSellableSqftInCents
  pricePerSellableSqftInCents
  contingencyInCents
  indirectCostInCents
  directCostInCents
  provisionalCostsInCents
  provisionalPercentage
  softCostInCents
  productOffering {
    ...Named
    contingencyMarkupPercentage
    aggregateLatest {
      id
    }
  }
  expandedOptions {
    id
  }
  pinnedOptions {
    id
    name
    globalOption {
      id
    }
    type {
      id
    }
  }
  programData {
    id
    sellableSqft
  }
}
    ${NamedFragmentDoc}`;
export const ConfigurationComparisonDimensionsDocument = gql`
    query ConfigurationComparisonDimensions($productOfferingIds: [ID!]!) {
  potentialBidPlanDimensions(
    productOfferingIds: $productOfferingIds
    kind: GlobalOptionType
    versionMode: LATEST
  ) {
    ...ConfigurationComparison_PotentialBidPlanDimensionResult
  }
}
    ${ConfigurationComparison_PotentialBidPlanDimensionResultFragmentDoc}`;

/**
 * __useConfigurationComparisonDimensionsQuery__
 *
 * To run a query within a React component, call `useConfigurationComparisonDimensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationComparisonDimensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigurationComparisonDimensionsQuery({
 *   variables: {
 *      productOfferingIds: // value for 'productOfferingIds'
 *   },
 * });
 */
export function useConfigurationComparisonDimensionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConfigurationComparisonDimensionsQuery, ConfigurationComparisonDimensionsQueryVariables> & ({ variables: ConfigurationComparisonDimensionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfigurationComparisonDimensionsQuery, ConfigurationComparisonDimensionsQueryVariables>(ConfigurationComparisonDimensionsDocument, options);
      }
export function useConfigurationComparisonDimensionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfigurationComparisonDimensionsQuery, ConfigurationComparisonDimensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfigurationComparisonDimensionsQuery, ConfigurationComparisonDimensionsQueryVariables>(ConfigurationComparisonDimensionsDocument, options);
        }
// @ts-ignore
export function useConfigurationComparisonDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConfigurationComparisonDimensionsQuery, ConfigurationComparisonDimensionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigurationComparisonDimensionsQuery, ConfigurationComparisonDimensionsQueryVariables>;
export function useConfigurationComparisonDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigurationComparisonDimensionsQuery, ConfigurationComparisonDimensionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigurationComparisonDimensionsQuery | undefined, ConfigurationComparisonDimensionsQueryVariables>;
export function useConfigurationComparisonDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigurationComparisonDimensionsQuery, ConfigurationComparisonDimensionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfigurationComparisonDimensionsQuery, ConfigurationComparisonDimensionsQueryVariables>(ConfigurationComparisonDimensionsDocument, options);
        }
export type ConfigurationComparisonDimensionsQueryHookResult = ReturnType<typeof useConfigurationComparisonDimensionsQuery>;
export type ConfigurationComparisonDimensionsLazyQueryHookResult = ReturnType<typeof useConfigurationComparisonDimensionsLazyQuery>;
export type ConfigurationComparisonDimensionsSuspenseQueryHookResult = ReturnType<typeof useConfigurationComparisonDimensionsSuspenseQuery>;
export type ConfigurationComparisonDimensionsQueryResult = ApolloReactCommon.QueryResult<ConfigurationComparisonDimensionsQuery, ConfigurationComparisonDimensionsQueryVariables>;
export const ConfigurationComparisonOptionsDocument = gql`
    query ConfigurationComparisonOptions($productOfferingIds: [ID!]!, $typeIds: [ID!]!) {
  readyPlanOptions(
    filter: {readyPlan: $productOfferingIds, type: $typeIds, active: true}
  ) {
    ...ConfigurationComparison_ReadyPlanOption
  }
}
    ${ConfigurationComparison_ReadyPlanOptionFragmentDoc}`;

/**
 * __useConfigurationComparisonOptionsQuery__
 *
 * To run a query within a React component, call `useConfigurationComparisonOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationComparisonOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigurationComparisonOptionsQuery({
 *   variables: {
 *      productOfferingIds: // value for 'productOfferingIds'
 *      typeIds: // value for 'typeIds'
 *   },
 * });
 */
export function useConfigurationComparisonOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConfigurationComparisonOptionsQuery, ConfigurationComparisonOptionsQueryVariables> & ({ variables: ConfigurationComparisonOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfigurationComparisonOptionsQuery, ConfigurationComparisonOptionsQueryVariables>(ConfigurationComparisonOptionsDocument, options);
      }
export function useConfigurationComparisonOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfigurationComparisonOptionsQuery, ConfigurationComparisonOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfigurationComparisonOptionsQuery, ConfigurationComparisonOptionsQueryVariables>(ConfigurationComparisonOptionsDocument, options);
        }
// @ts-ignore
export function useConfigurationComparisonOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConfigurationComparisonOptionsQuery, ConfigurationComparisonOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigurationComparisonOptionsQuery, ConfigurationComparisonOptionsQueryVariables>;
export function useConfigurationComparisonOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigurationComparisonOptionsQuery, ConfigurationComparisonOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigurationComparisonOptionsQuery | undefined, ConfigurationComparisonOptionsQueryVariables>;
export function useConfigurationComparisonOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigurationComparisonOptionsQuery, ConfigurationComparisonOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfigurationComparisonOptionsQuery, ConfigurationComparisonOptionsQueryVariables>(ConfigurationComparisonOptionsDocument, options);
        }
export type ConfigurationComparisonOptionsQueryHookResult = ReturnType<typeof useConfigurationComparisonOptionsQuery>;
export type ConfigurationComparisonOptionsLazyQueryHookResult = ReturnType<typeof useConfigurationComparisonOptionsLazyQuery>;
export type ConfigurationComparisonOptionsSuspenseQueryHookResult = ReturnType<typeof useConfigurationComparisonOptionsSuspenseQuery>;
export type ConfigurationComparisonOptionsQueryResult = ApolloReactCommon.QueryResult<ConfigurationComparisonOptionsQuery, ConfigurationComparisonOptionsQueryVariables>;
export const ConfigurationComparisonCombinationsDocument = gql`
    query ConfigurationComparisonCombinations($filter: CostConfigurationSummariesFilter, $page: PageFilter) {
  costConfigurationSummaries(filter: $filter, page: $page) {
    entities {
      ...ConfigurationComparison_Combination
    }
  }
}
    ${ConfigurationComparison_CombinationFragmentDoc}`;

/**
 * __useConfigurationComparisonCombinationsQuery__
 *
 * To run a query within a React component, call `useConfigurationComparisonCombinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationComparisonCombinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigurationComparisonCombinationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useConfigurationComparisonCombinationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ConfigurationComparisonCombinationsQuery, ConfigurationComparisonCombinationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfigurationComparisonCombinationsQuery, ConfigurationComparisonCombinationsQueryVariables>(ConfigurationComparisonCombinationsDocument, options);
      }
export function useConfigurationComparisonCombinationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfigurationComparisonCombinationsQuery, ConfigurationComparisonCombinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfigurationComparisonCombinationsQuery, ConfigurationComparisonCombinationsQueryVariables>(ConfigurationComparisonCombinationsDocument, options);
        }
// @ts-ignore
export function useConfigurationComparisonCombinationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConfigurationComparisonCombinationsQuery, ConfigurationComparisonCombinationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigurationComparisonCombinationsQuery, ConfigurationComparisonCombinationsQueryVariables>;
export function useConfigurationComparisonCombinationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigurationComparisonCombinationsQuery, ConfigurationComparisonCombinationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigurationComparisonCombinationsQuery | undefined, ConfigurationComparisonCombinationsQueryVariables>;
export function useConfigurationComparisonCombinationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigurationComparisonCombinationsQuery, ConfigurationComparisonCombinationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfigurationComparisonCombinationsQuery, ConfigurationComparisonCombinationsQueryVariables>(ConfigurationComparisonCombinationsDocument, options);
        }
export type ConfigurationComparisonCombinationsQueryHookResult = ReturnType<typeof useConfigurationComparisonCombinationsQuery>;
export type ConfigurationComparisonCombinationsLazyQueryHookResult = ReturnType<typeof useConfigurationComparisonCombinationsLazyQuery>;
export type ConfigurationComparisonCombinationsSuspenseQueryHookResult = ReturnType<typeof useConfigurationComparisonCombinationsSuspenseQuery>;
export type ConfigurationComparisonCombinationsQueryResult = ApolloReactCommon.QueryResult<ConfigurationComparisonCombinationsQuery, ConfigurationComparisonCombinationsQueryVariables>;
export const ConfigurationComparisonDocument = gql`
    query ConfigurationComparison($filter: CostConfigurationSummariesFilter, $page: PageFilter) {
  costConfigurationSummaries(filter: $filter, page: $page) {
    entities {
      ...ConfigurationComparison_CostConfigurationSummary
    }
  }
}
    ${ConfigurationComparison_CostConfigurationSummaryFragmentDoc}`;

/**
 * __useConfigurationComparisonQuery__
 *
 * To run a query within a React component, call `useConfigurationComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigurationComparisonQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useConfigurationComparisonQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ConfigurationComparisonQuery, ConfigurationComparisonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfigurationComparisonQuery, ConfigurationComparisonQueryVariables>(ConfigurationComparisonDocument, options);
      }
export function useConfigurationComparisonLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfigurationComparisonQuery, ConfigurationComparisonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfigurationComparisonQuery, ConfigurationComparisonQueryVariables>(ConfigurationComparisonDocument, options);
        }
// @ts-ignore
export function useConfigurationComparisonSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConfigurationComparisonQuery, ConfigurationComparisonQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigurationComparisonQuery, ConfigurationComparisonQueryVariables>;
export function useConfigurationComparisonSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigurationComparisonQuery, ConfigurationComparisonQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigurationComparisonQuery | undefined, ConfigurationComparisonQueryVariables>;
export function useConfigurationComparisonSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigurationComparisonQuery, ConfigurationComparisonQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfigurationComparisonQuery, ConfigurationComparisonQueryVariables>(ConfigurationComparisonDocument, options);
        }
export type ConfigurationComparisonQueryHookResult = ReturnType<typeof useConfigurationComparisonQuery>;
export type ConfigurationComparisonLazyQueryHookResult = ReturnType<typeof useConfigurationComparisonLazyQuery>;
export type ConfigurationComparisonSuspenseQueryHookResult = ReturnType<typeof useConfigurationComparisonSuspenseQuery>;
export type ConfigurationComparisonQueryResult = ApolloReactCommon.QueryResult<ConfigurationComparisonQuery, ConfigurationComparisonQueryVariables>;